import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/diaries/$diaryId/setup")({
    component: SetupLayout,
});

function SetupLayout() {
    return <Outlet />;
}
